var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.7501C1.83333 12.7501 1.47917 12.6042 1.1875 12.3126C0.895833 12.0209 0.75 11.6667 0.75 11.2501V9.00008H2V11.2501C2 11.3056 2.02778 11.3612 2.08333 11.4167C2.13889 11.4723 2.19444 11.5001 2.25 11.5001H11.75C11.8056 11.5001 11.8611 11.4723 11.9167 11.4167C11.9722 11.3612 12 11.3056 12 11.2501V9.00008H13.25V11.2501C13.25 11.6667 13.1042 12.0209 12.8125 12.3126C12.5208 12.6042 12.1667 12.7501 11.75 12.7501H2.25ZM7 9.52092L3.4375 5.95842L4.3125 5.04175L6.375 7.10425V0.104248H7.625V7.10425L9.6875 5.04175L10.5625 5.95842L7 9.52092Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7b17b5b25565816591aad42193bb9398.svg";
export { ForwardRef as ReactComponent };